// eslint-disable-next-line import/prefer-default-export
export function sortVehicles(vehicles, ids = []) {
    return ids.map(vehicleId => vehicles
        .find(vehicle => vehicle.id === vehicleId) ||
           { id: vehicleId, name: vehicleId })
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(vehicle => vehicle.id);
}
